import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

// All calls are client side for launch
export default async function geocode(param, isServer = false) {
  if (isServer) {
    try {
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${param.address}&key=${publicRuntimeConfig.googleMapsClientKey}`
      );
      const { results } = await res.json();
      return results;
    } catch (e) {
      throw new Error({ message: e });
    }
  } else {
    const geocoder = new window.google.maps.Geocoder();
    return new Promise((resolve, reject) => {
      geocoder.geocode(param, (result, status) => {
        if (status === 'OK') {
          resolve(result);
        } else {
          reject(status);
        }
      });
    });
  }
}
